import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BfiDataGrid, Column } from '../../common/SharedComponents';
import { BorrowerApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { GridSettingType } from '@apply/constants';
import { LinkType } from '../common/BorrowerConstants';
import { onActionsCellRender, executeAction } from '../common/BorrowerFunctions';
import { ActionType } from '../common/constants/ActionType';
import { useNavigate } from 'react-router-dom';

const CompaniesTable = ({ gridStore }) => {
    const searchState = useSelector((state) => state.searchState);
    const navigate = useNavigate();

    const borrowerApi = new BorrowerApi.BorrowerApi(applicationInsights);

    const [dataStore, set_dataStore] = useState(gridStore?.store);

    const dataFunction = (criteria) => {
        return borrowerApi.getCompaniesRecycleBin(criteria);
    };

    useEffect(() => {
        if (gridStore) {
            gridStore.setOnLoad('companyId', dataFunction, searchState?.searchText?.borrowerCompany);
            set_dataStore(gridStore.store);
        }
    }, [gridStore]);

    const onCellDblClick = (e) => {
        if (e.rowType !== 'data' || e.column.type === 'detailExpand' || e.column.type === 'actions') {
            return;
        }
        var model = {
            actionId: ActionType.EditCompany,
            companyId: e.data.companyId,
            linkType: LinkType.Company,
        };
        executeAction(model, navigate);
    };

    if (!gridStore) {
        return '';
    }

    return (
        <BfiDataGrid
            id={'borrowerEntitiesGrid'}
            gridType={GridSettingType.BorrowerCompanies}
            dataStore={dataStore}
            applicationInsights={applicationInsights}
            onCellDblClick={onCellDblClick}
        >
            <Column
                dataField='name'
                caption='Business Name'
            />
            <Column
                dataField='street1'
                caption='Street'
                width={300}
            />
            <Column
                dataField='city'
                caption='City'
                width={150}
            />
            <Column
                dataField='state'
                caption='State'
                width={70}
            />
            <Column
                type='actions'
                alignment='center'
                cellRender={(e) => onActionsCellRender(e, 'CompaniesGrid')}
                width={50}
                allowReordering={false}
                allowSorting={false}
                allowResizing={false}
                fixed={true}
                fixedPosition={'right'}
            />
        </BfiDataGrid>
    );
};

export default CompaniesTable;
